export const productsData= [
    {
        "id":1,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/000591/abzorb-anti-fungal-dusting-powder-100gm-2-1649918231.jpg",
        "name": "Abzorb Antifungal Dusting Powder 100gm",
        "price": 116,
        "OrigionalPrice": 142,
        "offer": 18,
    },
    {
        "id":2,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/270552/revital-h-men-multivitamin-with-calcium-zinc-ginseng-for-immunity-strong-bones-energy-30-capsules-2-1654077741.jpg",
        "name": "Revital H Men Multivitamin With Calcium, Zinc & Ginseng For Immunity, Strong Bones & Energy (30 Capsules)",
        "price": 263,
        "OrigionalPrice": 310,
        "offer": 15,
    },
    {
        "id":3,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/I11467/cremaffin-constipation-relief-liquid-mixed-fruit-225ml-2-1654167665.jpg",
        "name": "Cremaffin Constipation Relief Liquid - Mixed Fruit 225ml",
        "price": 190,
        "OrigionalPrice": 232,
        "offer": 18,
    },
    {
        "id":4,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/095587/iodex-ultra-body-pain-gel-tube-of-30-g-2-1654078322.jpg",
        "name": "Iodex Ultra Body Pain Gel Tube Of 30 G",
        "price": 132,
        "OrigionalPrice": "",
        "offer": "",
    },
    {
        "id":5,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/G30601/vicks-roll-on-inhaler-2-1641793160.jpg",
        "name": "Vicks Roll On Inhaler",
        "price": 75,
        "OrigionalPrice": 89,
        "offer": 15,
    },
    {
        "id":6,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/E20426/volini-pain-relief-spray-bottle-of-40g-2-1654169656.jpg",
        "name": "Volini Pain Relief Spray Bottle Of 40g",
        "price": 122,
        "OrigionalPrice": 149,
        "offer": 18,
    },
    {
        "id":7,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/080200/friends-easy-adult-diapers-medium-size-waist-28-44-inch-high-absorbency-anti-bacterial-core-10s-1-1654078325.jpg",
        "name": "Friends Easy Adult Diapers Medium Size - Waist 28-44 Inch - High Absorbency Anti-bacterial Core-10's",
        "price": 390,
        "OrigionalPrice": 550,
        "offer": 29,
    },
    {
        "id":8,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/E27502/brufen-power-pain-relief-spray-40g-800-sprays-2-1654251847.jpg",
        "name": "Brufen Power Pain Relief Spray 40g (800 Sprays)",
        "price": 105,
        "OrigionalPrice": 150,
        "offer": 30,
    },
    {
        "id":9,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/F22476/liveasy-wellness-ironfolic-acid-with-zinc-vitamin-cb12-maintains-overall-health-bottle-of-60-2-1641794058.jpg",
        "name": "Liveasy Wellness Iron+folic Acid With Zinc, Vitamin C&b12 - Maintains Overall Health - Bottle Of 60",
        "price": 533,
        "OrigionalPrice": 599,
        "offer": 10,
    },
    {
        "id":10,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/N65859/liveasy-essentials-aloe-vera-face-wipes-2-1646818934.jpg",
        "name": "Liveasy Essentials Aloe Vera Refreshing And Cleansing Face Wipes-20's",
        "price": 62,
        "OrigionalPrice": 69,
        "offer": 10,
    },
    {
        "id":11,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/B36597/canesten-antifungal-dusting-powder-50g-2-1650970284.jpg",
        "name": "Canesten Antifungal Dusting Powder 50",
        "price": 58.40,
        "OrigionalPrice": 73.00,
        "offer": 20,
    },
    {
        "id":12,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/D95288/onetouch-select-plus-simple-glucometer-with-10-free-strips-2-1645456739.jpg",
        "name": "Onetouch Select Plus Simple Glucometer With 10 Free Strips",
        "price": 871,
        "OrigionalPrice": 1147,
        "offer": 24,
    },
    {
        "id":13,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/P91768/accusure-pulse-oximeter-2-1654234170.jpg",
        "name": "Accusure Pulse Oximeter",
        "price": 719,
        "OrigionalPrice": 3999,
        "offer": 82,
    },
    {
        "id":14,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/239997/luciara-cream-safe-guard-against-stretch-marks-50-g-1-1654078411.jpg",
        "name": "Luciara Cream Safe-guard Against Stretch Marks",
        "price": 416,
        "OrigionalPrice": 595,
        "offer": 30,
    },
    {
        "id":15,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/G62192/liveasy-foods-chia-seeds-2-1654756874.jpg",
        "name": "Liveasy Foods Chia Seeds",
        "price": 224,
        "OrigionalPrice": 249,
        "offer": 10,
    },
    {
        "id":16,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/R91702/pediasure-7-vanilla-refill-400-gm-1-1654234038.jpg",
        "name": "Pediasure 7+ Vanilla Refill - 400 Gm",
        "price": 386,
        "OrigionalPrice": 425,
        "offer": 9,
    },
    {
        "id":17,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/I10558/everyuth-naturals-advanced-golden-glow-peel-off-mask-with-24k-gold-90-gm-2-1643980643.jpg",
        "name": "Everyuth Naturals Advanced Golden Glow Facewash",
        "price": 100,
        "OrigionalPrice": 125,
        "offer": 20,
    },
    {
        "id":18,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/T12046/lacto-calamine-face-wash-with-kaolin-clay-for-oily-skin-deep-cleanser-100-ml-2-1649841745.jpg",
        "name": "Lacto Calamine Face Wash With Kaolin Clay Facewash",
        "price": 94,
        "OrigionalPrice": 120,
        "offer": 21,
    },
    {
        "id":19,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/D44788/cremaffin-trial-stick-pack-of-15ml-pack-of-5-mint-2-1651912372.jpg",
        "name": "Cremaffin Trial Stick Pack Of 15ml (Pack Of 2)",
        "price": 59,
        "OrigionalPrice": 70,
        "offer": 15,
    },
    {
        "id":20,
        "img": "https://cdn01.pharmeasy.in/dam/products_otc/J78271/dr-morepen-garcinia-cambogia-for-weight-loss-800mg-with-60-hca-60-capsules-2-1641793812.jpg",
        "name": "Dr Morepen Garcinia Cambogia For Weight Gain",
        "price": 449,
        "OrigionalPrice": 899,
        "offer": 50,
    },
]